import React from "react";
import { ConcessionaireTemplate } from "../../Templates/ConcessionaireTemplate";

export const Concessionaire = () => {
  return <ConcessionaireTemplate />;
};
